// May need to move to Wisr Common
export const encodeObject = (object: Record<string, unknown>) => {
  try {
    return btoa(JSON.stringify(object));
  } catch {
    return "";
  }
};
